<template>
  <v-dialog
    v-model="show"
    max-width="40vw"
    @click:outside="cancel"
  >
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card-title class="justify-center text-h5">
        {{ label }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          class="multi-col-validation mt-6"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <date-picker
                v-model="publicationDate"
                label="Дата публикации"
                :rules="[rules.required]"
              ></date-picker>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="applicationTypes"
                :items="applicationTypesDropdown"
                :menu-props="{ maxHeight: '400' }"
                label="Типы приложений"
                multiple
                dense
                outlined
                persistent-hint
                hide-details
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="type"
                :items="applicationDescriptionTypesDropdown"
                :menu-props="{ maxHeight: '400' }"
                label="Тип"
                dense
                outlined
                persistent-hint
                hide-details
              ></v-select>
            </v-col>

            <v-spacer>
            </v-spacer>

            <v-col
              md="12"
              cols="24"
            >
              <translation-fields
                v-model="translations"
                :fields="translatedFields"
              />
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="saveData"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                type="reset"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import DatePicker from '@/components/date-picker'
import { rules } from '@/helpers/validation'
import TranslationFields from '@/components/translation-fields'

export default {
  name: 'ApplicationDescriptionForm',
  components: { TranslationFields, DatePicker },
  props: ['save', 'show', 'cancellation', 'label', 'descriptionType'],
  data: () => ({
    translatedFields: [
      { key: 'name', label: 'Наименование', required: true },
      { key: 'description', label: 'Описание', rich: true },
    ],
    icons: {
      mdiCheck,
      mdiClose,
    },
    rules,
  }),
  watch: {
    show(newValue) {
      if (newValue) {
        this.setType()
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      }
    },
  },
  computed: {
    ...mapFormHandlers('applicationDescription/form', [
      'translations',
      'publicationDate',
      'type',
      'applicationTypes',
    ]),
    ...mapGetters('dictionary', { applicationTypesDropdown: 'applicationTypesDropdown' }),
    ...mapGetters('dictionary', { applicationDescriptionTypesDropdown: 'applicationDescriptionTypesDropdown' }),
  },
  async mounted() {
    await this.fetchApplicationTypes()
    await this.fetchApplicationDescriptionTypes()
  },
  methods: {
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    setType() {
      this.type = this.descriptionType
    },
    ...mapActions('applicationDescription/form', ['resetForm']),
    ...mapActions('dictionary', {
      fetchApplicationTypes: 'fetchApplicationTypes',
      fetchApplicationDescriptionTypes: 'fetchApplicationDescriptionTypes',
    }),
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.save()
        this.resetForm()
      }
    },
  },
}
</script>
